export const SIGNUP_HEADERS = {
  PERSONAL_DETAILS: {
    id: 0,
    title: 'Create Account',
    // tslint:disable-next-line:quotemark
    caption: {
      // tslint:disable-next-line:quotemark
      preorder: "Let's get you ready for your pre-order",
      // tslint:disable-next-line:quotemark
      signup: "Let's get you setup to invest"
    }
  },
  CONTACT_INFORMATION: {
    id: 1,
    title: 'Contact Information',

    caption: {
      // tslint:disable-next-line:quotemark
      preorder: "Let's get you ready for your pre-order",
      signup: 'Provide a few more details'
    }
  },
  CONFIRM_PRE_ORDER_DETAILS: {
    id: 2,
    title: 'Confirm Pre-Order',
    // tslint:disable-next-line:quotemark
    caption: "Let's get you ready for your pre-order"
  }
};
